import { byCodeUnit } from "../sort";

/**
 * #1149: the one order of a connection's tables, before and after Save: the entity's name without
 * regard to case, then the name itself, both in byte order. A database connector names a table
 * `<schema>.<table>` (`dbo.customers`), so this is by schema, then by table. It reads the name
 * only, never `sourceSchema` or `sourceTable`, because a connection saved before its first
 * validation stores neither, and the order must not change when they arrive. The list a new
 * connection holds (the validator's answer, in source order) is put in this order on the client
 * (`inEntityOrder`) and the saved list is paged in it by the server (`DataflowService`
 * `ENTITY_ORDER_SQL`: `lower(entity_name) COLLATE "C"`, then `entity_name COLLATE "C"`), so the
 * database's locale never reorders it.
 */
export function compareEntities(a: { name: string }, b: { name: string }): number {
  return compareEntityNames(a.name, b.name);
}

/**
 * The same order over bare names: the run page's Tables grid, its live progress and the Run now
 * and retry pickers (`runTables.ts` `selectedTables`, the SQL form) list a run's tables in it too.
 */
export function compareEntityNames(a: string, b: string): number {
  return byCodeUnit(a.toLowerCase(), b.toLowerCase()) || byCodeUnit(a, b);
}

/** `ORDER BY` of `entity_name` in the one order, for a raw SQL read of `dataflow_entities`. */
export const ENTITY_NAME_ORDER_SQL = `lower(entity_name) COLLATE "C", entity_name COLLATE "C"`;

/** A copy of `entities` in the one order. */
export function inEntityOrder<T extends { name: string }>(entities: readonly T[]): T[] {
  return [...entities].sort(compareEntities);
}
